import { UncontrolledWhiteTooltip } from '../basics/WhiteTooltip';
import NewTabAnchor from '../basics/NewTabAnchor';

const SuitabilityInfoTooltip = ({ target }) => {
  return (
    <UncontrolledWhiteTooltip
      placement="right"
      target={target}
      flip={false}
      modifiers={{ preventOverflow: { boundariesElement: 'viewport' } }}
      autohide={false}
    >
      <div className="font-tiny text-muted">
        <span>
          Crop suitability in our model is based on 12 environmental factors,
          derived from various sources. 8 of them are soil based, and are
          extracted from&nbsp;
        </span>
        <NewTabAnchor href="https://www.nrcs.usda.gov/wps/portal/nrcs/detail/soils/survey/?cid=nrcs142p2_053627">
          SSURGO
        </NewTabAnchor>
        <span>
          &nbsp;(Soil Survey Geographic Database), collected by the National
          Cooperative Soil Survey, an effort on the part of the USDA to collect
          information about soil across the United States. The crop model scores
          a crop based on a locations characteristics. The scores are based upon
          each crops adaptation to the underlying environmental factors.
        </span>
      </div>
    </UncontrolledWhiteTooltip>
  );
};

export default SuitabilityInfoTooltip;
